import {
  useEngineInstance,
  useEnginePagination,
  UseEnginePaginationSelector
} from '@surveycake/react-logic-engine';
import { fade } from 'app/shared/styles';
import { isInIframe, userAgent, hiddenSubmitEnable } from 'config/system';
import React, { memo, useEffect, useLayoutEffect, useMemo } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Breadcrumb from './Breadcrumb';
import * as styles from './styles';
import Subjects from './Subjects';
import SubmitContainer from './SubmitContainer';
import SurveyHeader from './SurveyHeader';

const pageSelector: UseEnginePaginationSelector<number> = pagination =>
  pagination.current;

function Content() {
  const engine = useEngineInstance();
  const { multiplePages, manualPages, hidden_submit_enable } = useMemo(() => {
    const data = engine.getSurveyData();
    return {
      multiplePages: data.multiplePages,
      manualPages: data.manualPages,
      hidden_submit_enable: data.hidden_submit_enable
    };
  }, [engine]);
  const page = useEnginePagination(pageSelector);
  const isReadyPage = multiplePages && isNaN(page);
  const isSubmitPage = multiplePages && page === Infinity;
  const showBreadcrumb =
    !(isReadyPage || isSubmitPage) && multiplePages && !manualPages;
  const showHeader = isReadyPage || !multiplePages;
  const showSubjects = !(isReadyPage || isSubmitPage) || !multiplePages;
  const showSubmit =
    (isSubmitPage || !multiplePages) &&
    !(hiddenSubmitEnable && hidden_submit_enable);

  useLayoutEffect(() => {
    if (userAgent.isIOSVersionBelow12 && isInIframe) {
      document.querySelector('#iOS12IframeHackWrapper')!.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [page]);

  useEffect(() => {
    if (isInIframe && multiplePages) {
      window.parent.postMessage(
        { type: 'GO_PAGE', payload: { current: page } },
        '*'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <TransitionGroup className={styles.transitionGroup}>
      <CSSTransition key={page} classNames={fade} timeout={250}>
        <div className={styles.content} aria-label="survey content">
          {showBreadcrumb && <Breadcrumb />}
          {showHeader && <SurveyHeader />}
          {showSubjects && <Subjects />}
          {showSubmit && <SubmitContainer />}
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default memo(Content);
